export default "__VITE_ASSET__739e9f40__"